import { EventEmitter } from 'events';
import { ChangeEvent, TranscriptionEvent } from './utils';
import { FailureActionTypes, FailureContinuation } from '../common/enums/failureEnums';
import { FailureState } from '../pages';
import Dispatcher from '../dispatcher';

const defaultState: FailureState = {
  failureReason: '',
  failureContinuation: FailureContinuation.None
};

class FailureStore extends EventEmitter {
  private state: FailureState;

  constructor() {
    super();

    this.state = this.getInitialState();
  }

  private getInitialState = (): FailureState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, defaultState);
  }

  public getState = (): FailureState => {
    // Make sure we are not passing a reference to the object
    return Object.assign({}, this.state);
  }

  public handleActions = (action: Event): void => {
    switch(action.type) {
      case FailureActionTypes.SetFailureReasonAction:
        this.state.failureReason = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case FailureActionTypes.SetFailureContinuationAction:
        this.state.failureContinuation = (<TranscriptionEvent> action).payload;
        this.emit(ChangeEvent.Change);
        break;
      case FailureActionTypes.RevertStateAction:
        this.state = this.getInitialState();
        this.emit(ChangeEvent.Change);
        break;
    }
  }
}

const failureStore = new FailureStore;
Dispatcher.register(failureStore.handleActions);
export default failureStore;
